import React from 'react';
import PropTypes from 'prop-types';
import OrderStatus from './OrderStatus';
import { returnOrderRequestStatuses } from '../../utils/format';

const OrderStatusInfo = ({ order, showDescription = false }) => {
  if (
    !!order.customerRequestType &&
    order.customerRequestStatus === 'pending'
  ) {
    const values = returnOrderRequestStatuses(
      order.customerRequestType,
      order.customerRequestStatus
    );

    return (
      <React.Fragment>
        <>
          <div className="entry-status warning">
            <span className="entry-status__badge badge badge--dot badge-warning"></span>
            <span className="entry-status__label color--warning">
              {values.title}
            </span>
          </div>

          {showDescription && values.description}
        </>
      </React.Fragment>
    );
  }

  return (
    <OrderStatus status={order.status} showDescription={showDescription} />
  );
};

OrderStatusInfo.defaultProps = {
  status: null,
  showDescription: false,
};
OrderStatusInfo.propTypes = {
  status: PropTypes.string,
  showDescription: PropTypes.bool,
};

export default OrderStatusInfo;
